function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.073 4.98314C31.8841 4.6445 31.5258 4.43408 31.138 4.43408H4.86133C4.47358 4.43408 4.1153 4.6445 3.92608 4.9834L0.666625 10.8284C0.479467 11.1637 0.483866 11.5612 0.678256 11.8921C0.872391 12.2233 1.21749 12.4208 1.60136 12.4208H3.61457V27.8008H2.60668C2.01652 27.8008 1.53623 28.2811 1.53623 28.8716V30.4952C1.53623 31.0856 2.01652 31.5659 2.60668 31.5659H33.3927C33.9829 31.5659 34.4632 31.0856 34.4632 30.4952V28.8716C34.4632 28.2811 33.9829 27.8008 33.3927 27.8008H32.3848V12.4208H34.3978C34.7814 12.4208 35.1265 12.2233 35.3209 11.8924C35.5153 11.5615 35.5199 11.1639 35.333 10.8284L32.073 4.98314ZM21.3708 16.4087H28.3199V27.8008H21.3708C21.3705 26.0546 21.3701 16.3365 21.3708 16.4087ZM33.4043 28.8716V30.4952C33.4043 30.5017 33.3992 30.5071 33.3927 30.5071L2.59505 30.4952L2.60668 28.8597L33.4043 28.8716ZM31.326 27.8008H29.3787V15.8793C29.3787 15.5869 29.1416 15.3498 28.8493 15.3498H20.8414C20.549 15.3498 20.312 15.5869 20.312 15.8793V27.8008H4.6734V12.4208H31.326V27.8008ZM34.3978 11.3619L1.59128 11.3441L4.86133 5.49291L31.1484 5.49885L34.4034 11.3614C34.4034 11.3614 34.4019 11.3619 34.3978 11.3619Z",
  fill: "url(#paint0_linear_2052_38438)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.15051 24.104H16.965C17.2574 24.104 17.4945 23.867 17.4945 23.5746V16.6467C17.4945 16.3544 17.2574 16.1173 16.965 16.1173H7.15051C6.85814 16.1173 6.62109 16.3544 6.62109 16.6467V23.5746C6.62109 23.867 6.85814 24.104 7.15051 24.104ZM16.4356 23.0452H12.5873V17.1761H16.4356V23.0452ZM7.67992 17.1761H11.5285V23.0452H7.67992V17.1761Z",
  fill: "#A60078"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.547 21.5751H22.4648V22.6339H23.547V21.5751Z",
  fill: "#A60078"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2006 6.74612H10.2114C9.91906 6.74612 9.68202 6.98317 9.68202 7.27554C9.68202 7.5679 9.91906 7.80495 10.2114 7.80495H12.2006C12.493 7.80495 12.73 7.5679 12.73 7.27554C12.73 6.98317 12.493 6.74612 12.2006 6.74612ZM8.03458 6.74612H6.37707C6.0847 6.74612 5.84766 6.98317 5.84766 7.27554C5.84766 7.5679 6.0847 7.80495 6.37707 7.80495H8.03458C8.32695 7.80495 8.56399 7.5679 8.56399 7.27554C8.56399 6.98317 8.32695 6.74612 8.03458 6.74612Z",
  fill: "#A60078"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2052_38438",
  x1: 2.49976,
  y1: 2,
  x2: 34.9998,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A60078"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E401A5"
})));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.649cb535.svg";
export { ForwardRef as ReactComponent };